import "./newEvents.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { DriveFolderUploadOutlined as UploadIcon } from "@mui/icons-material";
import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  CircularProgress,
} from "@mui/material";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";
import { useSelector } from "react-redux";

const NewEvents = ({ inputs, title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate(); // Initialize navigate

  const { state } = useLocation(); // Access state passed from navigate
  const eventData = state?.event || {}; // Extract Event data or use an empty object

  // populate formData with eventData if editing
  const [formData, setFormData] = useState({
    userId: eventData.userId || userIdRedux,
    eventName: eventData.eventName || "",
    eventAddress: eventData.eventAddress || "",
    eventDescription: eventData.eventDescription || "",
    eventOrganizerPhone: eventData.eventOrganizerPhone || "",
    eventDate: eventData.eventDate || "",
    eventTime: eventData.eventTime || "",
    createdDate: eventData.createdDate || "",
    eventImages: eventData.eventImages || [],
  });

  const [createdDate, setCreatedDate] = useState(eventData.createdDate || "");
  const [eventDate, setEventDate] = useState(eventData.eventDate || "");

  const [eventImages, setEventImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");

  const validateForm = () => {
    const errors = {};

    if (!formData.eventName) errors.eventName = "Name is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.eventName))
    //   errors.eventName = "Name must be a string.";

    if (!formData.eventAddress) errors.eventAddress = "Address is required.";

    if (!formData.eventDescription)
      errors.eventDescription = "Description is required.";

    if (!formData.eventOrganizerPhone)
      errors.eventOrganizerPhone = "Phone number is required.";
    if (!/^\d{10}$/.test(formData.eventOrganizerPhone))
      errors.eventOrganizerPhone = "Phone number must be 10 digits.";

    if (!eventDate) errors.eventDate = "Event Date is required.";
    if (!formData.eventTime) errors.eventTime = "Event Time is required.";
    if (!createdDate) errors.createdDate = "Created Date is required.";

    if (eventImages.length === 0)
      errors.eventImages = "At least 3 image must be uploaded.";
    if (eventImages.length < 3)
      // Changed from 0 to 3
      errors.eventImages = "Event 3 images are required.";
    if (eventImages.length > 3)
      // Changed from 0 to 3
      errors.eventImages = "Select Not more than 3 Event images.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const validImages = files.filter((file) => {
      if (!file.type.startsWith("image/")) {
        alert(`File "${file.name}" is not a valid image.`);
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        alert(`File "${file.name}" exceeds the 5MB size limit.`);
        return false;
      }
      return true;
    });

    if (validImages.length > 0) {
      setFormData({ ...formData, eventImages: validImages });

      // Generate image previews
      const previews = validImages.map((file) => URL.createObjectURL(file));
      setEventImages(previews);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setBackEndError("");

    const formDataToSubmit = new FormData();

    formDataToSubmit.append("userId", formData.userId);
    formDataToSubmit.append("eventName", formData.eventName);
    formDataToSubmit.append("eventAddress", formData.eventAddress);
    formDataToSubmit.append("eventDescription", formData.eventDescription);
    formDataToSubmit.append(
      "eventOrganizerPhone",
      formData.eventOrganizerPhone,
    );
    formDataToSubmit.append("eventDate", eventDate);
    formDataToSubmit.append("eventTime", formData.eventTime);
    formDataToSubmit.append("createdDate", createdDate);

    formData.eventImages.forEach((file, index) =>
      formDataToSubmit.append("eventImages", file),
    );

    /**
     * choosing URL whether to update or add formDataToSubmit.append("userId", formData.userId);
     *
     */
    const MAIN_URL = eventData._id
      ? `${BASE_URL}/api/events/updateEvent/${eventData._id}`
      : `${BASE_URL}/api/events/addEvent`;

    try {
      let response = "";
      if (eventData._id) {
        response = await axios.put(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        response = await axios.post(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (response.status === 201) {
        setBackEndError(<font color="green">Success TO ADD DATA.</font>);
        navigate("/events");
      } else if (response.status === 200) {
        setBackEndError(<font color="green">Success TO UPDATE DATA.</font>);
        navigate("/events");
      } else if (response.status === 401) {
        //alert or show error message
        setBackEndError(<font color="red">USER ALREADY EXISTS.</font>);
      } else if (response.status === 400) {
        //alert or show error message
        setBackEndError(<font color="red">ALL THE FIELDS ARE REQUIRED.</font>);
      } else if (response.status === 402) {
        //alert or show error message
        setBackEndError(<font color="red">INVALID USER DATA.</font>);
      }
    } catch (error) {
      const errorMessage = error.response.data.msg;
      setBackEndError(<span style={{ color: "red" }}>{errorMessage}</span>);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <form
            onSubmit={handleSubmit}
            style={{
              display: "grid",
              gap: "1rem",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="eventName"
                label="Event Name"
                type="text"
                value={formData.eventName}
                onChange={handleChange}
                error={Boolean(errors.eventName)}
                helperText={errors.eventName}
                fullWidth
                margin="normal"
                required
              />
              <div style={{ flex: 3 }}>
                <InputLabel style={{ flex: 1 }}>Created Date</InputLabel>
                <FormControl
                  style={{ flex: 2 }}
                  margin="normal"
                  error={Boolean(errors.createdDate)}
                >
                  <NepaliDatePicker
                    inputClassName="form-control"
                    value={createdDate}
                    onChange={(value) => setCreatedDate(value)}
                    options={{ calenderLocale: "ne", valueLocale: "en" }}
                  />
                  {errors.createdDate && (
                    <FormHelperText>{errors.createdDate}</FormHelperText>
                  )}
                </FormControl>
              </div>
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="eventAddress"
                label="Address"
                type="text"
                value={formData.eventAddress}
                onChange={handleChange}
                error={Boolean(errors.eventAddress)}
                helperText={errors.eventAddress}
                fullWidth
                margin="normal"
                required
              />
              {/* Another TextField or empty space for 1/4 size */}
              <TextField
                style={{ flex: 3 }}
                name="eventOrganizerPhone"
                label="Oroganizer Phone"
                type="number"
                value={formData.eventOrganizerPhone}
                onChange={handleChange}
                error={Boolean(errors.eventOrganizerPhone)}
                helperText={errors.eventOrganizerPhone}
                fullWidth
                margin="normal"
                required
              />
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <div style={{ flex: 3 }}>
                <InputLabel style={{ flex: 1 }}>Event Date</InputLabel>
                <FormControl
                  style={{ flex: 2 }}
                  margin="normal"
                  error={Boolean(errors.eventDate)}
                >
                  <NepaliDatePicker
                    inputClassName="form-control"
                    value={eventDate}
                    onChange={(value) => setEventDate(value)}
                    options={{ calenderLocale: "ne", valueLocale: "en" }}
                  />
                  {errors.eventDate && (
                    <FormHelperText>{errors.eventDate}</FormHelperText>
                  )}
                </FormControl>
              </div>

              <TextField
                style={{ flex: 3 }}
                name="eventTime"
                label="Event Time"
                type="text"
                value={formData.eventTime}
                onChange={handleChange}
                error={Boolean(errors.eventTime)}
                helperText={errors.travelAddress}
                fullWidth
                margin="normal"
                required
              />

              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 6 }}
                name="eventDescription"
                label="Description"
                value={formData.eventDescription}
                onChange={handleChange}
                multiline
                rows={4} // Number of rows for the text area
                fullWidth
                variant="outlined"
                error={Boolean(errors.eventDescription)}
                helperText={errors.eventDescription}
                margin="normal"
                required
              />
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <Button
                variant="outlined"
                component="label"
                startIcon={<UploadIcon />}
                style={{ margin: "10px 0" }}
              >
                Upload Images
                <input
                  id="eventImages"
                  name="eventImages"
                  type="file"
                  multiple
                  hidden
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Button>
            </div>
            {errors.eventImages && (
              <span className="error-message">{errors.eventImages}</span>
            )}
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {eventImages.map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt={`Preview ${index + 1}`}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "5px",
                  }}
                />
              ))}
            </div>

            <span className="error-message">{backEndError}</span>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ borderRadius: "15px", width: "50%" }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" /> // Show loading spinner
              ) : (
                "Save"
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewEvents;
